<template>
  <div class="social bg-white FoundersGrotesk">
    <b-container>
      <b-row class="pb-5">
        <b-col class="m-0 p-0" cols="12" md="6">
          <p class="lg-text">PRESS</p></b-col
        >
        <b-col cols="12" md="6" class="m-0 p-0">
          <div class="md-text">
            <a
              target="_blank"
              href="mailto:tiffany@odetoronto.ca"
              class="link-text"
              >FOR MEDIA INQUIRIES ></a
            >
          </div>
        </b-col>
      </b-row>

      <a
        href="https://www.nytimes.com/interactive/2024/04/11/travel/things-to-do-toronto.html"
        target="_blank"
        rel="noopener noreferrer"
      >
        <b-row class="press-container">
          <b-col cols="12" md="4" class="p-0">
            <img
              src="/img/press/nytimes-press.jpg"
              alt="36 Hours in Toronto - The New York Times"
              class="img-fluid d-block w-100 image-hover"
            />
          </b-col>
          <b-col cols="12" md="7" class="press-title">
            <div class="overlay-text">
              <span>36 HOURS IN TORONTO: THINGS TO DO AND SEE</span>THE NEW YORK
              TIMES
            </div>
          </b-col>
          <b-col cols="12" md="1" class="p-0">
            <img
              src="/img/press/forward.svg"
              alt="Go Button"
              class="img-fluid d-block go-btn"
            />
          </b-col>
        </b-row>
      </a>

      <a
        href="https://www.vogue.com/article/toronto-city-guide"
        target="_blank"
        rel="noopener noreferrer"
      >
        <b-row class="press-container">
          <b-col cols="12" md="4" class="p-0">
            <img
              src="/img/press/vogue.jpg"
              alt="Ode Instagram"
              class="img-fluid d-block w-100 image-hover"
            />
          </b-col>
          <b-col cols="12" md="7" class="press-title">
            <div class="overlay-text">
              <span>A LOCAL’S GUIDE TO TORONTO</span>VOGUE
            </div>
          </b-col>
          <b-col cols="12" md="1" class="p-0">
            <img
              src="/img/press/forward.svg"
              alt="Go Button"
              class="img-fluid d-block go-btn"
            />
          </b-col>
        </b-row>
      </a>

      <a
        href="https://www.vogue.com/best-hotels-in-toronto"
        target="_blank"
        rel="noopener noreferrer"
      >
        <b-row class="press-container">
          <b-col cols="12" md="4" class="p-0">
            <img
              src="/img/press/6H5A2760.jpg"
              alt="Ode Instagram"
              class="img-fluid d-block w-100 image-hover"
            />
          </b-col>
          <b-col cols="12" md="7" class="press-title">
            <div class="overlay-text">
              <span
                >FOR A SLEEK CITY STAY, BOOK ONE OF THE BEST HOTELS IN
                TORONTO</span
              >VOGUE
            </div>
          </b-col>
          <b-col cols="12" md="1" class="p-0">
            <img
              src="/img/press/forward.svg"
              alt="Go Button"
              class="img-fluid d-block go-btn"
            />
          </b-col>
        </b-row>
      </a>

      <a
        href="https://www.forbes.com/sites/byronarmstrong/2025/07/10/beyond-the-mini-bar-how-hotels-are-reimagining-the-modern-art-gallery/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <b-row class="press-container">
          <b-col cols="12" md="4" class="p-0">
            <img
              src="/img/press/GreyRoom.jpg"
              alt="Ode Instagram"
              class="img-fluid d-block w-100 image-hover"
            />
          </b-col>
          <b-col cols="12" md="7" class="press-title">
            <div class="overlay-text">
              <span
                >BEYOND THE MINI-BAR: HOW HOTELS ARE REIMAGINING THE MODERN ART
                GALLERY</span
              >FORBES
            </div>
          </b-col>
          <b-col cols="12" md="1" class="p-0">
            <img
              src="/img/press/forward.svg"
              alt="Go Button"
              class="img-fluid d-block go-btn"
            />
          </b-col>
        </b-row>
      </a>

      <a
        href="https://www.afar.com/magazine/how-to-spend-a-day-in-toronto-according-to-a-local"
        target="_blank"
        rel="noopener noreferrer"
      >
        <b-row class="press-container">
          <b-col cols="12" md="4" class="p-0">
            <img
              src="/img/press/afar.jpg"
              alt="Ode Instagram"
              class="img-fluid d-block w-100 image-hover"
            />
          </b-col>
          <b-col cols="12" md="7" class="press-title">
            <div class="overlay-text">
              <span>A LOCAL’S GUIDE TO THE PERFECT DAY IN TORONTO</span>AFAR
            </div>
          </b-col>
          <b-col cols="12" md="1" class="p-0">
            <img
              src="/img/press/forward.svg"
              alt="Go Button"
              class="img-fluid d-block go-btn"
            />
          </b-col>
        </b-row>
      </a>
      <a
        href="https://www.blogto.com/hotels/ode-toronto/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <b-row class="press-container">
          <b-col cols="12" md="4" class="p-0">
            <img
              src="/img/press/blogto.jpg"
              alt="Ode Instagram"
              class="img-fluid d-block w-100 image-hover"
            />
          </b-col>
          <b-col cols="12" md="7" class="press-title">
            <div class="overlay-text"><span>ODE HOTEL TORONTO</span>BLOGTO</div>
          </b-col>
          <b-col cols="12" md="1" class="p-0">
            <img
              src="/img/press/forward.svg"
              alt="Go Button"
              class="img-fluid d-block go-btn"
            />
          </b-col>
        </b-row>
      </a>

      <a
        href="https://dailyhive.com/vancouver/erica-herbert-ode-toronto-black-history-month"
        target="_blank"
        rel="noopener noreferrer"
      >
        <b-row class="press-container">
          <b-col cols="12" md="4" class="p-0">
            <img
              src="/img/press/daily.jpg"
              alt="Ode Instagram"
              class="img-fluid d-block w-100 image-hover"
            />
          </b-col>
          <b-col cols="12" md="7" class="press-title">
            <div class="overlay-text">
              <span
                >CREATING A LEGACY: HOW BLACK BUSINESS-OWNER ERICA HERBERT IS
                BUILDING GENERATIONAL WEALTH</span
              >DAILY HIVE
            </div>
          </b-col>
          <b-col cols="12" md="1" class="p-0">
            <img
              src="/img/press/forward.svg"
              alt="Go Button"
              class="img-fluid d-block go-btn"
            />
          </b-col>
        </b-row>
      </a>

      <a
        href="https://www.designlinesmagazine.com/spaces/ode-toronto/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <b-row class="press-container">
          <b-col cols="12" md="4" class="p-0">
            <img
              src="/img/press/6H5A2286.jpg"
              alt="Ode Instagram"
              class="img-fluid d-block w-100 image-hover"
            />
          </b-col>
          <b-col cols="12" md="7" class="press-title">
            <div class="overlay-text">
              <span
                >ODE IS TORONTO'S BLACK-OWNED HOTEL ROOTED IN PLACE, PRIDE AND
                COMMUNITY</span
              >DESIGNLINES
            </div>
          </b-col>
          <b-col cols="12" md="1" class="p-0">
            <img
              src="/img/press/forward.svg"
              alt="Go Button"
              class="img-fluid d-block go-btn"
            />
          </b-col>
        </b-row>
      </a>

      <a
        href="https://www.destinationtoronto.com/leisure-blog/post/black-owned-businesses-toronto/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <b-row class="press-container">
          <b-col cols="12" md="4" class="p-0">
            <img
              src="/img/press/destination.jpg"
              alt="Ode Instagram"
              class="img-fluid d-block w-100 image-hover"
            />
          </b-col>
          <b-col cols="12" md="7" class="press-title">
            <div class="overlay-text">
              <span>10 BLACK-OWNED BUSINESSES TO DISCOVER IN 2023</span
              >DESTINATION TORONTO
            </div>
          </b-col>
          <b-col cols="12" md="1" class="p-0">
            <img
              src="/img/press/forward.svg"
              alt="Go Button"
              class="img-fluid d-block go-btn"
            />
          </b-col>
        </b-row>
      </a>

      <a
        href="https://www.hgtv.ca/home-feel-like-a-boutique-hotel-ode-toronto/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <b-row class="press-container">
          <b-col cols="12" md="4" class="p-0">
            <img
              src="/img/press/hgtv.jpg"
              alt="Ode Instagram"
              class="img-fluid d-block w-100 image-hover"
            />
          </b-col>
          <b-col cols="12" md="7" class="press-title">
            <div class="overlay-text">
              <span
                >HOW TO MAKE YOUR HOME FEEL LIKE A TRENDY, BOUTIQUE HOTEL</span
              >HGTV
            </div>
          </b-col>
          <b-col cols="12" md="1" class="p-0">
            <img
              src="/img/press/forward.svg"
              alt="Go Button"
              class="img-fluid d-block go-btn"
            />
          </b-col>
        </b-row>
      </a>

      <a
        href="https://travelnoire.com/ode-the-black-owned-hostel-bringing-a-caribbean-guest-house-vibe-to-toronto"
        target="_blank"
        rel="noopener noreferrer"
      >
        <b-row class="press-container">
          <b-col cols="12" md="4" class="p-0">
            <img
              src="/img/press/noir.jpg"
              alt="Ode Instagram"
              class="img-fluid d-block w-100 image-hover"
            />
          </b-col>
          <b-col cols="12" md="7" class="press-title">
            <div class="overlay-text">
              <span
                >ODE: THE BLACK-OWNED HOSTEL BRINGING A CARIBBEAN GUEST HOUSE
                VIBE TO TORONTO </span
              >TRAVEL NOIRE
            </div>
          </b-col>
          <b-col cols="12" md="1" class="p-0">
            <img
              src="/img/press/forward.svg"
              alt="Go Button"
              class="img-fluid d-block go-btn"
            />
          </b-col>
        </b-row>
      </a>

      <a
        href="https://thesoulhaus.com/a-stay-at-ode-torontos-best-kept-secret/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <b-row class="press-container">
          <b-col cols="12" md="4" class="p-0">
            <img
              src="/img/press/6H5A8844.jpg"
              alt="Ode Instagram"
              class="img-fluid d-block w-100 image-hover"
            />
          </b-col>
          <b-col cols="12" md="7" class="press-title">
            <div class="overlay-text">
              <span>A STAY AT ODE, TORONTO'S BEST KEPT SECRET</span>THE SOUL
              HAUS
            </div>
          </b-col>
          <b-col cols="12" md="1" class="p-0">
            <img
              src="/img/press/forward.svg"
              alt="Go Button"
              class="img-fluid d-block go-btn"
            />
          </b-col>
        </b-row>
      </a>

      <a
        href="https://1883magazine.com/a-stay-at-ode-hotel-toronto/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <b-row class="press-container">
          <b-col cols="12" md="4" class="p-0">
            <img
              src="/img/press/Room8.jpg"
              alt="Ode Instagram"
              class="img-fluid d-block w-100 image-hover"
            />
          </b-col>
          <b-col cols="12" md="7" class="press-title">
            <div class="overlay-text">
              <span>A STAY AT ODE HOTEL TORONTO</span>1883 MAGAZINE
            </div>
          </b-col>
          <b-col cols="12" md="1" class="p-0">
            <img
              src="/img/press/forward.svg"
              alt="Go Button"
              class="img-fluid d-block go-btn"
            />
          </b-col>
        </b-row>
      </a>
    </b-container>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
export default {
  data() {
    return {};
  },
  components: {},
  mounted() {
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.refresh();
    setTimeout(() => {}, 500);
  },
  methods: {},
};
</script>

<style scoped lang="scss">
@import "~@/assets/styles/variables";
.social {
  padding: 50px 50px 100px 50px;
  @media screen and (max-width: 1176px) {
    padding: 40px 40px 50px 40px;
  }
  a:link,
  a:visited,
  a:active {
    color: $m-black;
    text-decoration: none;
  }
  .link-text {
    letter-spacing: 1px;
    position: absolute;
    top: 60px;
    right: 0;
    @media screen and (max-width: 768px) {
      top: 0;
    }
  }
  .press-container {
    border-top: 1.5px solid black;
    padding-top: 15px;
    padding-bottom: 40px;
  }
  .press-title {
    padding: 0px 100px 0px 20px;
    @media screen and (max-width: 768px) {
      padding: 20px 0px;
    }
  }
  .image-hover {
    transition: opacity 0.3s;
  }
  .go-btn {
    width: 100%;
    @media screen and (max-width: 768px) {
      width: 60px;
      position: absolute;
      right: 0;
    }
  }
  .border-press {
    border: 2px solid black;
  }
  .border-press:hover .image-hover:hover {
    opacity: 0.7;
  }
  .overlay-text {
    font-weight: lighter;
    font-size: 16px;
    line-height: 1em;
    @media screen and (max-width: 500px) {
      font-size: 15px;
    }
  }
  span:hover {
    text-decoration: underline;
  }
  span {
    font-weight: 500;
    display: block;
    font-size: 30px;
    line-height: 1em;
    padding-bottom: 10px;
    @media screen and (max-width: 500px) {
      font-size: 20px;
    }
  }
}
</style>
